<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 223.817"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="41.034"
            cy="76.823"
            r="9.965"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M24.618 51.862c5.387,8.761 14.591,15.04 25.587,14.863 9.322,-0.151 17.643,-5.51 23.344,-12.965 -5.379,-4.588 -10.932,-7.609 -16.66,-9.061 -4.689,-1.189 -9.494,-1.327 -14.417,-0.415 -5.79,1.073 -11.741,3.599 -17.854,7.578z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M41.697 14.44c4.663,0.786 9.594,0.992 14.791,0.619 5.463,-0.391 11.221,-1.423 17.274,-3.094 -5.216,-5.249 -12.907,-8.295 -22.472,-8.215 -8.145,0.069 -15.364,2.897 -20.859,7.451 3.564,1.495 7.319,2.574 11.266,3.239z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M42.472 44.284c-0.661,-9.301 -0.919,-19.249 -0.775,-29.844 -3.947,-0.665 -7.702,-1.744 -11.266,-3.239 -6.914,5.732 -11.096,14.197 -10.948,23.336 0.088,5.487 1.598,10.937 4.223,15.751 0.29,0.532 0.595,1.057 0.912,1.574 6.113,-3.979 12.064,-6.505 17.854,-7.578z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M41.697 14.44c-0.144,10.595 0.114,20.543 0.775,29.844 4.923,-0.912 9.728,-0.774 14.417,0.415 1.749,-6.11 1.615,-15.99 -0.401,-29.64 -5.197,0.373 -10.128,0.167 -14.791,-0.619z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M56.488 15.059c2.016,13.65 2.15,23.53 0.401,29.64 5.728,1.452 11.281,4.473 16.66,9.061 0.615,-0.805 1.201,-1.635 1.753,-2.485 3.935,-6.054 6.217,-13.15 6.108,-19.87 -0.126,-7.873 -2.833,-14.595 -7.648,-19.44 -6.053,1.671 -11.811,2.703 -17.274,3.094z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M51.29 3.75c-18.393,0.154 -32.072,14.385 -31.807,30.787 0.264,16.402 13.223,32.47 30.722,32.188 17.499,-0.283 31.47,-18.918 31.205,-35.32 -0.264,-16.402 -11.726,-27.809 -30.12,-27.655zm24.012 47.525c1.351,51.491 -3.961,116.349 -15.549,149.731 -10.876,19.56 -20.245,-19.94 -25.041,-75.954 -4.159,-28.749 -3.228,-57.502 -11.006,-74.764"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="51.859"
            cy="210.101"
            r="9.965"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
